var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"tmc-fy-select",attrs:{"id":"tmcFySelect","value":_vm.value,"items":_vm.sortedFyRange,"item-text":"name","item-value":"year","label":"By FY"},on:{"change":function (val) { return _vm.changed(val); }}})}
var staticRenderFns = []

export { render, staticRenderFns }